import React from 'react';
import styled from 'styled-components';

import { useIsMobile } from '#/hooks/useIsMobile';

type ComponentProps = {
  children?: never;
  height: string | number;
  noMobile?: boolean;
};

/**
 * Props for the top level wrapper element.  This is separate from the
 * definition due to syntax highlighting issues when defining inline
 */
type WrapperProps = {
  $height: string | number;
};

const Wrapper = styled.div<WrapperProps>`
  /* don't ever let this shrink in height if direct descendent of flex */
  flex-shrink: 0;
  height: ${props =>
    typeof props.$height === 'number' ? `${props.$height}px` : props.$height};
`;

/**
 * Provides vertical spacing and useful for providing spacing without the need
 * for margins or paddings which, if used incorrectly, can often cause unwanted
 * effects.
 */
export default function Spacer(props: ComponentProps) {
  const isMobile = useIsMobile();
  const { children, height, noMobile } = props;

  if (noMobile && isMobile) {
    return null;
  }

  return <Wrapper $height={height}>{children}</Wrapper>;
}
